import React from 'react';

function SuccessScreen() {
  return (
    <div className="success-screen">
      <div className="success-icon" role="img" aria-label="Success">
        ✅
      </div>
      <h1 className="success-title">Report sent.</h1>
      <p className="success-sub">Thank you. Have a great rest of your shift.</p>
    </div>
  );
}

export default SuccessScreen;
